import styled from 'styled-components';

import { Card as DefaultCard } from '@xing-com/card';
import { mediaConfined } from '@xing-com/layout-tokens';
import { SkeletonCard as InnerSkeletonCard } from '@xing-com/skeleton';
import { Headline as DefaultHeadline } from '@xing-com/typography';

const largeHeight = '180px';
const smallHeight = '160px';

export const Card = styled(DefaultCard)<{ background?: string }>`
  width: 100%;
  height: ${smallHeight};
  ${({ background }) => (background ? `background-color: ${background};` : '')}
  color: #1D2124;
  border: 0;

  & > div {
    height: 100%;
    justify-content: space-between;
  }

  @media ${mediaConfined} {
    height: ${largeHeight};
  }
`;
export const Headline = styled(DefaultHeadline)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SkeletonCard = styled(InnerSkeletonCard)`
  display: flex;
  flex-direction: column;
  min-height: ${smallHeight};
  justify-content: space-between;

  @media ${mediaConfined} {
    height: ${largeHeight};
  }
`;
